import { ICellRendererProps } from 'common/components/table/table.types';
import { IActivityLogRead } from 'features/eiq-manage/service/activity-logs-service/activity-logs.service.types';
import { IntegrationEventPayloadModal } from '../eiq-manage-integration-events/integration-event-payload-modal/integration-event-payload-modal';
import { ActivityLogsJsonDiffModal } from './activity-logs-json-diff-modal/activity-logs-json-diff-modal';

export const activityLogsTableInitialColumns = [
  {
    key: 'entityType',
    title: 'Entity Type',
    dataKey: 'entityType',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'entityId',
    title: 'Entity Id',
    dataKey: 'entityId',
    width: 150,
    minWidth: 100,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },

  {
    key: 'oldValue',
    title: 'Old Value',
    dataKey: 'oldValue',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IActivityLogRead>) => {
      return cell.cellData && <IntegrationEventPayloadModal payload={cell.cellData} />;
    },
  },
  {
    key: 'newValue',
    title: 'New Value',
    dataKey: 'newValue',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IActivityLogRead>) => {
      return cell.cellData && <IntegrationEventPayloadModal payload={cell.cellData} />;
    },
  },
  {
    key: 'diff',
    title: 'Difference',
    dataKey: 'diff',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IActivityLogRead>) => {
      return cell.rowData && <ActivityLogsJsonDiffModal newValue={cell.rowData.newValue} oldValue={cell.rowData.oldValue} />;
    },
  },
  {
    key: 'occurredAt',
    title: 'Occurred At (UTC)',
    dataKey: 'occurredAt',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'userId',
    title: 'User Id',
    dataKey: 'userId',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'userType',
    title: 'User Type',
    dataKey: 'userType',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'userName',
    title: 'User Name',
    dataKey: 'userName',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'action',
    title: 'Action',
    dataKey: 'action',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
];
